module.exports = __webpack_public_path__ + "static/media/publicity2.dff18455.png";